const discover = [
    'discover-your-purple',
    'discover-purpose-driven',
    'discover-a-place-to-belong',
    'discover-your-best-self',
    'discover-what-success-looks-like',
    'discover-your-story'
]

const recruitment = [
    '1',
    '2',
]

// Get the proper {alias} array based on the given {mode} 
export const getAliasesByMode = (mode) => {
    switch (mode) {
        case 'discover':
            return discover
        default:
            return recruitment
    }
} 